export const MELBOURNE_TIMEZONE = 'Australia/Melbourne';
